/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * メディア種類
 * @export
 * @interface OurMediaOutletMediaType
 */
export interface OurMediaOutletMediaType {
    /**
     * メディア種類ID
     * @type {number}
     * @memberof OurMediaOutletMediaType
     */
    id: number;
    /**
     * メディア種類名
     * @type {string}
     * @memberof OurMediaOutletMediaType
     */
    name: string;
}

/**
 * Check if a given object implements the OurMediaOutletMediaType interface.
 */
export function instanceOfOurMediaOutletMediaType(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function OurMediaOutletMediaTypeFromJSON(json: any): OurMediaOutletMediaType {
    return OurMediaOutletMediaTypeFromJSONTyped(json, false);
}

export function OurMediaOutletMediaTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OurMediaOutletMediaType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OurMediaOutletMediaTypeToJSON(value?: OurMediaOutletMediaType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

